import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
} from '@angular/core';
import { Table } from 'primeng/table';
import { PaginatorService } from './paginator.service';

@Component({
  selector: 'ui-paginator',
  standalone: true,
  providers: [PaginatorService],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent<TData> {
  public readonly paginatorService = inject(PaginatorService<TData>);

  public readonly value = input.required<TData[]>();
  public readonly table = input.required<Table>();
  public readonly paginatorLabelSuffix = input('');

  protected readonly label = computed(() => {
    const first = this.paginatorService.first();
    const rows = this.paginatorService.rows();
    const totalRecords = this.paginatorService.totalRecords();
    const suffix = this.paginatorLabelSuffix();

    const displayedRecords = Math.min(first + rows, totalRecords);

    return `Showing ${displayedRecords} of ${totalRecords} ${suffix}`;
  });

  private readonly _initPaginatorEffect = effect(
    () => this.paginatorService.init(this.value(), this.table()),
    { allowSignalWrites: true },
  );

  private readonly _setPaginatorValueEffect = effect(
    () => this.paginatorService.setValue(this.value()),
    { allowSignalWrites: true },
  );
}
